'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
// SELECT users.id AS "users:id", ...
// => [ { users: { id, ... } } ]
function nest(rows, fields, spell) {
    var e_1, _a;
    var Model = spell.Model;
    var tableAlias = Model.tableAlias;
    var results = [];
    try {
        for (var rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
            var row = rows_1_1.value;
            var result = {};
            var qualified = Object.keys(row).some(function (entry) { return entry.includes(':'); });
            for (var key in row) {
                var parts = key.split(':');
                var _b = __read(qualified
                    ? (parts.length > 1 ? parts : ['', key])
                    : [Model.attributeMap.hasOwnProperty(key) ? tableAlias : '', key], 2), qualifier = _b[0], column = _b[1];
                var obj = result[qualifier] || (result[qualifier] = {});
                obj[column] = row[key];
            }
            results.push(result);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { rows: results, fields: fields };
}
var Connection = /** @class */ (function () {
    function Connection(_a) {
        var client = _a.client, databasePath = _a.database, mode = _a.mode, pool = _a.pool, busyTimeout = _a.busyTimeout;
        var Database = client.Database, OPEN_READWRITE = client.OPEN_READWRITE, OPEN_CREATE = client.OPEN_CREATE;
        if (mode == null)
            mode = OPEN_READWRITE | OPEN_CREATE;
        var database = new Database(databasePath, mode);
        // SQLITE_BUSY
        // - https://www.sqlite.org/rescode.html#busy
        // - https://www.sqlite.org/c3ref/busy_timeout.html
        // - https://github.com/mapbox/node-sqlite3/wiki/API#databaseconfigureoption-value
        if (busyTimeout > 0)
            database.configure('busyTimeout', busyTimeout);
        this.database = database;
        this.pool = pool;
    }
    Connection.prototype.query = function (query, values, spell) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, sql, nestTables, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = query.sql ? query : { sql: query }, sql = _a.sql, nestTables = _a.nestTables;
                        if (!/^(?:pragma|select)/i.test(sql)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.all(sql, values)];
                    case 1:
                        result = _b.sent();
                        if (nestTables)
                            return [2 /*return*/, nest(result.rows, result.fields, spell)];
                        return [2 /*return*/, result];
                    case 2: return [4 /*yield*/, this.run(sql, values)];
                    case 3: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    Connection.prototype.all = function (sql, values) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.database.all(sql, values, function Leoric_all(err, rows, fields) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve({ rows: rows, fields: fields });
                }
            });
        });
    };
    Connection.prototype.run = function (sql, values) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.database.run(sql, values, function Leoric_run(err) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve({ insertId: this.lastID, affectedRows: this.changes });
                }
            });
        });
    };
    Connection.prototype.release = function () {
        this.pool.releaseConnection(this);
    };
    Connection.prototype.end = function () {
        return __awaiter(this, void 0, void 0, function () {
            var connections, index;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connections = this.pool.connections;
                        index = connections.indexOf(this);
                        if (index >= 0)
                            connections.splice(index, 1);
                        return [4 /*yield*/, this.close()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Connection.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            _this.database.close(function Leoric_end(err) {
                                if (err) {
                                    reject(err);
                                }
                                else {
                                    resolve();
                                }
                            });
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return Connection;
}());
module.exports = Connection;
//# sourceMappingURL=connection.js.map